import React from "react";
import "./howToWorkRow.css";

export default function HowToWorkRow() {
    return (
        <section className="htw container" dir="rtl">
            <h2 className="htw__title">كيف يشتغل <span>“تحرّر”</span>؟</h2>

            <div className="htw__grid">

                <div className="htw-card__wrapper">
                    <article className="htw-card" aria-label="التعافي" tabIndex="0">
                        <div className="htw-card__badge">1</div>
                        <h3 className="htw-card__title">التعافي</h3>
                        <p className="htw-card__text">فهم جروحك وأنماطك العميقة.</p>
                    </article>
                    <div className="htw-card__underline" />
                </div>

                <div className="htw-card__wrapper">
                    <article className="htw-card" aria-label="النمو" tabIndex="0">
                        <div className="htw-card__badge">2</div>
                        <h3 className="htw-card__title">النمو</h3>
                        <p className="htw-card__text">
                            أدوات تنظّم يومك، تدعم قراراتك وعلاقاتك.
                        </p>
                    </article>
                    <div className="htw-card__underline" />
                </div>

                <div className="htw-card__wrapper">
                    <article className="htw-card" aria-label="جودة حياة" tabIndex="0">
                        <div className="htw-card__badge">3</div>
                        <h3 className="htw-card__title">جودة حياة</h3>
                        <p className="htw-card__text">
                            راحة داخلية، طموح واقعي، وحب أعمق للحياة.
                        </p>
                    </article>
                    <div className="htw-card__underline" />
                </div>

            </div>

            <p className="htw__note">
                ومع استشارات من نخبة الأخصّائيين النفسيين والأطباء المعتمدين، تحصل على
                دعم علمي وإنساني يساعدك تواجه تحدياتك بخطوات مدروسة.
            </p>
        </section>
    );
}
